import create from 'zustand';

export interface GeneratingParams {
  generatePath: string;
  gradeBand: string;
  programId?: number;
  sectionId: number;
}

interface ReadingLevelGeneratingState {
  clearGenerating: () => void;
  failed: GeneratingParams | null;
  generated: string[];
  generating: GeneratingParams | null;
  markGenerated: (sectionId: number, gradeBand: string) => void;
  rateLimited: boolean;
  setFailed: (params: GeneratingParams) => void;
  setRateLimited: (rateLimited: boolean) => void;
  startGenerating: (params: GeneratingParams) => void;
}

const useReadingLevelGeneratingStore = create<ReadingLevelGeneratingState>((set, get) => ({
  clearGenerating: () => set({ generating: null }),
  failed: null,
  // AIDEV-NOTE: `generated` is in-memory only — cleared on full page reload.
  // Tracks sectionId:gradeBand pairs generated this session so the dropdown navigates instead of re-triggering.
  generated: [],
  generating: null,
  markGenerated: (sectionId, gradeBand) => {
    const key = `${sectionId}:${gradeBand}`;
    if (get().generated.includes(key)) return;
    set({ generated: [...get().generated, key] });
  },
  rateLimited: false,
  setFailed: params => set({ failed: params }),
  setRateLimited: rateLimited => set({ rateLimited }),
  startGenerating: params => set({ failed: null, generating: params }),
}));

export default useReadingLevelGeneratingStore;
